"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalSlide = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ModalSlide = props => {
  let {
      description,
      src,
      title,
      variant
    } = props,
    slideSrc = null;
  if (src) {
    if (variant === 'img') {
      slideSrc = /*#__PURE__*/React.createElement("img", {
        className: "kui-modal__slide-img",
        src: src
      });
    } else if (variant === 'video') {
      slideSrc = /*#__PURE__*/React.createElement("iframe", {
        allowFullScreen: true,
        className: "kui-modal__slide-video",
        frameBorder: 0,
        src: src
      });
    }
  }
  return /*#__PURE__*/React.createElement("div", null, !!slideSrc && /*#__PURE__*/React.createElement("div", {
    className: "kui-modal__slide-src"
  }, slideSrc), /*#__PURE__*/React.createElement("div", {
    className: "kui-modal__slide-description ".concat(slideSrc ? '' : 'flexable'),
    dangerouslySetInnerHTML: {
      __html: description
    }
  }));
};
exports.ModalSlide = ModalSlide;
ModalSlide.defaultProps = {
  description: '',
  src: null,
  title: '',
  variant: 'img'
};
ModalSlide.displayName = 'ModalSlide';